import { render, staticRenderFns } from "./IconInCustomerTaxReturn.vue?vue&type=template&id=793acf0e"
import script from "./IconInCustomerTaxReturn.vue?vue&type=script&lang=js"
export * from "./IconInCustomerTaxReturn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('793acf0e')) {
      api.createRecord('793acf0e', component.options)
    } else {
      api.reload('793acf0e', component.options)
    }
    module.hot.accept("./IconInCustomerTaxReturn.vue?vue&type=template&id=793acf0e", function () {
      api.rerender('793acf0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/components/IconInCustomerTaxReturn.vue"
export default component.exports